import { ArrowsRightLeftIcon, BookOpenIcon, HandThumbUpIcon, NoSymbolIcon, RectangleGroupIcon, UserIcon } from '@heroicons/react/24/solid';

export enum AuditActions {
  UPDATE = 'UPDATED',
  CREATE = 'CREATED',
  CHANGED = 'CHANGED',
}

export const EventTypes: { [key: string]: { icon: React.ReactNode } } = {
  UPDATE: {
    icon: <ArrowsRightLeftIcon className='h-5 w-5 text-blue-500' />,
  },
  SUBMITTED: {
    icon: <UserIcon className='h-5 w-5 text-neutralColor-normal' />,
  },
  CREATE: {
    icon: <RectangleGroupIcon className='h-5 w-5 text-neutralColor-normal' />,
  },
  UNDER_REVIEW: {
    icon: <BookOpenIcon className='h-5 w-5 text-secondaryColor-normal' />,
  },
  DENY: { icon: <NoSymbolIcon className='h-5 w-5 text-tertiaryColor-normal' /> },
  HOLD: { icon: <ArrowsRightLeftIcon className='h-5 w-5 text-cyan' /> },
  APPROVED: {
    icon: <HandThumbUpIcon className='h-5 w-5' />,
  },
};
